import { type CustomEventData, type EventName } from './types';
import { trackEvent } from './track';

export const track = (eventName: EventName, customData?: CustomEventData) => {
  trackEvent(eventName, customData);
};
